module.exports = __webpack_public_path__ + "static/IMG-20200803-WA0038-1bf0097ce65cf1a9113b13542599fdf9.jpg";